import { createFileRoute, redirect } from "@tanstack/react-router";

export const Route = createFileRoute("/_layout/user/")({
  beforeLoad: () => {
    throw redirect({ to: "/user/influencer" });
  },
});
